import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextFormInput from '../Text';
import Icon from '../../../core/Icon';
import formatting from '../../../utils/formatting';
import dataGridActions from '../../../data/actions/grid';
import FormDialog from '../../containers/Dialog';
import { MultiSelect } from '../../field/MultiSelect';
import { DataSelect } from '../../field/DataSelect';

var useFilterDependencies = function useFilterDependencies(dependency) {
  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1]; //load dependencies


  React.useEffect(function () {
    if (dependency === 'event') {
      //load interactive projects into cache
      dataGridActions().load({
        id: 'correspondenceProjects',
        dataType: 'correspondence',
        itemsPerPage: 9999
      }).then(function () {
        setLoading(false);
      });
    }
  }, [dependency]);
  return {
    loading: loading
  };
}; //CATEGORY:CorrespondenceSubmittedEvent;SOURCE:22222222-2222-2222-2222-222222222489;COUNT-MIN:1;LIST:1789


var deserialize = function deserialize(value) {
  if (!value) return {};
  var params = value.split(';');
  var keys = {};
  params.map(function (param) {
    var pair = param.split(':');
    keys[pair[0]] = pair[1];
  });
  return keys;
};

var serialize = function serialize(params) {
  var out = '';
  Object.keys(params).map(function (key) {
    if (out) out = out + ';';
    out += key + ':' + params[key];
  });
  return out;
};

var getPrettyValue = function getPrettyValue(value) {
  var params = deserialize(value);
  var category = params['CATEGORY'];
  var source = params['SOURCE']; // const list = params['LIST'];

  if (category) {
    if (category === 'CorrespondenceSubmittedEvent') {
      if (!source) return '';
      var projectName = formatting.placeholders('{label}', {
        dataType: 'correspondence',
        id: source
      });
      if (!projectName) return 'Form Submitted';
      return projectName + ' Submitted';
    }

    return category;
  }

  return 'Advanced Expression';
};

var Label = function Label(_ref) {
  var children = _ref.children;
  return React.createElement(Typography, {
    style: {
      marginTop: 8,
      marginBottom: -8
    }
  }, children);
};
/**
 * @param {import('./types').FormInputFilterExpressionValueProps & import('../commonTypes').FormInputDisabled & { color: import('./types').FormInputFilterProps["color"] } } props
 */


var FilterExpressionValueEventFormInput = React.forwardRef(function (_ref2, ref) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      disabled = _ref2.disabled,
      variant = _ref2.variant,
      color = _ref2.color;

  var _useFilterDependencie = useFilterDependencies('event'),
      loading = _useFilterDependencie.loading;

  var eventValue = deserialize(value);
  var prettyValue = getPrettyValue(value);

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isOpen = _React$useState4[0],
      toggle = _React$useState4[1];

  React.useEffect(function () {
    ref.current = {
      focus: function focus() {
        return toggle(true);
      }
    };
  }, [ref]);
  var input = React.createElement(TextFormInput, {
    onClick: function onClick() {
      return toggle(true);
    },
    value: prettyValue,
    readOnly: true,
    disabled: disabled,
    variant: variant,
    placeholder: "Create filter...",
    color: color,
    InputProps: {
      endAdornment: React.createElement(Icon, {
        type: loading ? 'loading' : 'menu-down',
        style: {
          opacity: 0.25,
          marginRight: loading ? -10 : -14
        }
      })
    },
    inputProps: {
      style: {
        cursor: 'pointer'
      }
    }
  });
  return React.createElement(React.Fragment, null, input, isOpen && React.createElement(FormDialog, {
    defaultValue: {
      CATEGORY: eventValue['CATEGORY'],
      SOURCE: eventValue['SOURCE']
    },
    onSuccess: function onSuccess(values) {
      onChange(serialize(values));
      toggle(false);
    },
    onCancel: function onCancel() {
      return toggle(false);
    },
    hideCancelButton: true,
    variant: variant,
    disabled: disabled,
    color: color,
    submitLabel: "Save",
    windowProps: {
      header: 'Event'
    }
  }, React.createElement(Label, null, "Category"), React.createElement(MultiSelect, {
    required: true,
    name: "CATEGORY",
    label: null,
    options: [{
      label: 'Correspondence Submitted',
      value: 'CorrespondenceSubmittedEvent'
    }]
  }), React.createElement(Label, null, "Source"), React.createElement(DataSelect, {
    required: true,
    name: "SOURCE",
    label: null,
    placeholder: "Select form...",
    dataType: "correspondence",
    id: "correspondences"
  })));
});
FilterExpressionValueEventFormInput.defaultProps = {};
export default FilterExpressionValueEventFormInput;